import {type OrderTypes} from '../order';
import {
  type LinkedWindow, type LinkerDataType, type QEPSharePublishData, type QEPShareSubscribeData,
} from '../linker';
import {type ApplicationClientType} from './application-client';
import {type MessageRequest} from './pubsub';

/** Linker listener registration with typed enum payloads and legacy custom topic support. */
type LinkerSubscription = {
  <T extends LinkerDataType, K extends OrderTypes | undefined = undefined>(topic: T, cb?: (message: QEPShareSubscribeData<T, K>) => void): void;
  <Payload = unknown>(topic: string, cb?: (message: Payload) => void): void;
};

export type LinkerApi = {
  applicationClient: ApplicationClientType;
  componentId?: string;
  initialize: () => Promise<void>;
  onLinkBroadcast: (message: MessageRequest) => void;
  openWindowAndLink: (publishData: QEPSharePublishData<LinkerDataType>, linkerGroups: string[]) => Promise<void>;
  registerLink: (groupId: string, windowId: string, componentId?: string) => Promise<string[]>;
  deRegisterLink: (groupId: string, windowId: string) => Promise<string[]>;
  getWindowLinks: () => Promise<string[]>;
  getLinkedWindows: (links: string[]) => Promise<LinkedWindow[]>;
  linkToChannel: (groupdId: string) => void;
  publish: (publishData: QEPSharePublishData<LinkerDataType, OrderTypes | undefined>) => Promise<void>;
  publishOrOpenWindow: <T extends LinkerDataType, K extends OrderTypes | undefined = undefined>(
    publishData: QEPSharePublishData<T, K>,
  ) => Promise<void | MessageRequest>;
  subscribe: LinkerSubscription;
  unsubscribe: LinkerSubscription;
};
